import indonesia from './indonesia.svg';
import philippines from './philippines.svg';
import srilanka from './srilanka.svg';
import australia from './australia.svg';

export default {
indonesia, philippines, srilanka, australia
}
